import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import ElectionDetail from "@/pages/ElectionDetail";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";
import Vote from "@/pages/Vote";
import PublicResults from "@/pages/PublicResults";
import { Terms, Privacy } from "@/pages/Legal";
import PaymentCallback from "@/pages/PaymentCallback";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import LiveMonitor from "@/pages/LiveMonitor";
import SuperAdmin from "@/pages/SuperAdmin";
import Attest from "@/pages/Attest";
import Kiosk from "@/pages/Kiosk";
import { HowItWorks, Security, Pricing } from "@/pages/Marketing";
import Guide from "@/pages/Guide";
import GuideApp from "@/pages/GuideApp";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-400 font-mono text-sm">
        loading…
      </div>
    );
  if (user === false) return <Navigate to="/auth" replace />;
  if (user.role === "superadmin") return <Navigate to="/superadmin" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/accept-invite/:token" element={<AcceptInvite />} />
            <Route path="/vote/:token" element={<Vote />} />
            <Route path="/register/:id" element={<Register />} />
            <Route path="/kiosk/:id" element={<Kiosk />} />
            <Route path="/attest/:token" element={<Attest />} />            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/results/:id" element={<PublicResults />} />
            <Route path="/live/:id" element={<LiveMonitor />} />
            <Route path="/superadmin" element={<SuperAdmin />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/security" element={<Security />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/callback" element={<PaymentCallback />} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/elections/:id" element={<Protected><ElectionDetail /></Protected>} />
            <Route path="/app/elections/:id/monitor" element={<Protected><LiveMonitor embedded /></Protected>} />
            <Route path="/app/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/app/guide" element={<Protected><GuideApp /></Protected>} />
            <Route path="/app/profile" element={<Protected><Profile /></Protected>} />            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
